import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
  effect,
} from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

// Child tab components
import { MeetdayTabGeneralComponent } from "./tabs/meetday-tab-general.component";
import { MeetdayTabRoundsComponent } from "./tabs/meetday-tab-rounds.component";
import { MeetdayTabCompaniesComponent } from "./tabs/meetday-tab-companies.component";
import { MeetdayTabRegistrationsComponent } from "./tabs/meetday-tab-registrations.component";
import { MeetdayTabEmailsComponent } from "./tabs/meetday-tab-emails.component";

// Facade
import { MeetdayModalFacade } from "./meetday-modal.facade";
import { MeetDay } from "../../../api/models/meet-day";

@Component({
  selector: "app-modal-admin-meetday",
  templateUrl: "./modal-admin-meetday.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MeetdayModalFacade],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MeetdayTabGeneralComponent,
    MeetdayTabRoundsComponent,
    MeetdayTabCompaniesComponent,
    MeetdayTabRegistrationsComponent,
    MeetdayTabEmailsComponent,
  ],
})
export class ModalAdminMeetdayComponent implements OnInit {
  public activeModal = inject(NgbActiveModal);
  public facade = inject(MeetdayModalFacade);
  public activeTab = "general";

  // Data passed from parent via componentInstance.data
  public data: { entity: MeetDay } = { entity: {} as MeetDay };

  constructor() {
    // When switching to simple mode, redirect from rounds tab to general tab
    effect(() => {
      if (!this.facade.showRoundsTab() && this.activeTab === "rounds") {
        this.activeTab = "general";
      }
    });
  }

  ngOnInit(): void {
    this.facade.initialize(this.data.entity);
  }

  // ========== Modal Actions ==========

  close(): void {
    this.activeModal.dismiss(false);
  }

  save(): void {
    this.facade.save().subscribe((success) => {
      if (success) {
        this.activeModal.close(true);
      }
    });
  }
}
